const HORIZONTAL_PLP_CONSTANTS = {
  SET_HORIZONTAL_PLP_LOADING: 'SET_HORIZONTAL_PLP_LOADING',
  FETCH_HORIZONTAL_CATEGORY_PRODUCTS: 'FETCH_HORIZONTAL_CATEGORY_PRODUCTS',
  FETCH_MORE_HORIZONTAL_CATEGORY_PRODUCTS: 'FETCH_MORE_HORIZONTAL_CATEGORY_PRODUCTS',
  RESET_HORIZONTAL_CATEGORY_PRODUCTS: 'RESET_HORIZONTAL_CATEGORY_PRODUCTS',
  SET_HORIZONTAL_CATEGORY_PRODUCTS: 'SET_HORIZONTAL_CATEGORY_PRODUCTS',
  SET_HLP_SUBCATEGORIES_FETCHED: 'SET_HLP_SUBCATEGORIES_FETCHED',
  SET_HLP_CID: 'SET_HLP_CID',
  SET_HORIZONTAL_SEO_DATA: 'SET_HORIZONTAL_SEO_DATA',
  CLEAR_HORIZONTAL_SEO_DATA: 'CLEAR_HORIZONTAL_SEO_DATA',
  SET_HPLP_APPLIED_SORT_ID: 'SET_HPLP_APPLIED_SORT_ID',
  SET_HPLP_FILTERS: 'SET_HPLP_FILTERS',
  SET_HPLP_APPLIED_FILTERS: 'SET_HPLP_APPLIED_FILTERS',
  SET_IS_HPLP: 'SET_IS_HPLP',
  FETCH_HORIZONTAL_CATEGORY_PRODUCTS_APP: 'FETCH_HORIZONTAL_CATEGORY_PRODUCTS_APP',
  FETCH_INITIAL_HPLP_DATA: 'FETCH_INITIAL_HPLP_DATA',
  SET_HPLP_INITIAL_DATA_LOADING: 'SET_HPLP_INITIAL_DATA_LOADING',
};
export const CATEGORIES_TO_EXCLUDE = ['Gymboree', 'Sugar & Jade'];
export default HORIZONTAL_PLP_CONSTANTS;
